/**
 * Вид страницы расчёта (WS 15587410, комментарий 25.09): «лента» — все блоки подряд,
 * как было; «вкладки» — как в софте Игоря, блок открывается по клику и занимает всю
 * страницу под полосой итогов. Первая вкладка — «Сводка», дальше в порядке ленты.
 *
 * Выбор вида запоминается у пользователя. Хранилище может быть недоступно (приватное
 * окно, запрет на данные сайта) — тогда просто открывается лента.
 */

export type DashboardViewMode = 'feed' | 'tabs';

export const VIEW_STORAGE_KEY = 'idea_calc.dashboard_view.v1';

export interface PageSection {
  id: string;
  titleKey: string;
}

/** Блоки ленты — якоря для прокрутки. «Сводка» стоит рядом с калькулятором и своего якоря нет. */
export const FEED_SECTIONS: readonly PageSection[] = [
  { id: 'calculator', titleKey: 'idea_calc.header.nav_calculator' },
  { id: 'score', titleKey: 'idea_calc.header.nav_score' },
  { id: 'budget', titleKey: 'idea_calc.header.nav_budget' },
  { id: 'competitor-analysis', titleKey: 'idea_calc.header.nav_competitors' },
  { id: 'sales-plan', titleKey: 'idea_calc.header.nav_sales_plan' },
  { id: 'forecast', titleKey: 'idea_calc.header.nav_forecast' },
  { id: 'summary', titleKey: 'idea_calc.header.nav_summary' },
  { id: 'notes', titleKey: 'idea_calc.header.nav_notes' },
];

export const UNIT_SUMMARY_ID = 'unit-summary';

/** Вкладки: «Сводка» первой, остальные — как в ленте. */
export const TAB_SECTIONS: readonly PageSection[] = [
  { id: UNIT_SUMMARY_ID, titleKey: 'idea_calc.header.nav_unit_summary' },
  ...FEED_SECTIONS,
];

export function loadViewMode(): DashboardViewMode {
  try {
    return localStorage.getItem(VIEW_STORAGE_KEY) === 'tabs' ? 'tabs' : 'feed';
  } catch {
    return 'feed';
  }
}

export function storeViewMode(mode: DashboardViewMode): void {
  try {
    localStorage.setItem(VIEW_STORAGE_KEY, mode);
  } catch {
    // Без хранилища выбор живёт до перезагрузки — это не ошибка.
  }
}

/** Виден ли блок: в ленте — все, во вкладках — только открытый. */
export function isSectionShown(mode: DashboardViewMode, activeTab: string, id: string): boolean {
  return mode === 'feed' || activeTab === id;
}
